import type { Event, EventHint } from "@sentry/core";
import { z } from "zod";
import { remiLogger } from "@remi/logging";

const AblyErrorInfoSchema = z.object({
  code: z.number(),
  statusCode: z.number(),
  message: z.string(),
});

// Ably code -> the one statusCode that makes it suppressible. Matching on the code alone would
// swallow (80003, 400), a normal retriable blip, and (80019, 403), a real auth misconfiguration.
const SUPPRESSIBLE_ABLY_ERRORS: ReadonlyMap<number, number> = new Map([
  [80003, 404],
  [80017, 400],
  [90007, 408],
  [90000, 409],
  [80019, 401],
]);

export function dropSuppressibleAblyError<T extends Event>(event: T, hint: EventHint): T | null {
  const parsed = AblyErrorInfoSchema.safeParse(hint.originalException);
  if (!parsed.success || SUPPRESSIBLE_ABLY_ERRORS.get(parsed.data.code) !== parsed.data.statusCode) {
    return event;
  }

  remiLogger.captureCounterMetric("ably.error.suppressed", 1, {
    attributes: { code: String(parsed.data.code), statusCode: String(parsed.data.statusCode) },
  });
  return null;
}
